// @TODO <HEALTH2019>
// @TODO $rootScope added
App.controller('HealthInsuranceWithPaymentsPackageCtrl', ['$scope', '$sce', '$state', '$http', '$mdDialog', 'Config', 'packageService', 'branchService', '$stateParams', 'dataUser', 'healthInsuranceService', 'moment', '$rootScope', function ($scope, $sce, $state, $http, $mdDialog, Config, packageService, branchService, $stateParams, dataUser, healthInsuranceService, moment, $rootScope) {
// @TODO </HEALTH2019>
    $scope.stateParams = $stateParams;

    // TOD-MZ
    $scope.page = 'healthInsurance';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Moja deklaracja (wybierz pakiet)';
    $scope.$emit('step', $scope.step);

    // if (true) {
    //     return;
    // }

    function updatePackageWeight() {
        if ($scope.last && $scope.package && $scope.package.length) {
            var benefit = $scope.last.benefit;

            if (benefit.type !== 'REHABILITATION') {
                return;
            }
            var variantFound;
            angular.forEach($scope.package, function (variant) {
                if (variantFound) {
                    return;
                }

                if (variant.codeName === benefit.variant) {
                    variantFound = variant;
                }
            });

            if (!variantFound || !variantFound.options.length) {
                return;
            }

            var typeFound;
            angular.forEach(variantFound.options, function (type) {
                if (type.type === benefit.type) {
                    typeFound = type;
                }
            });

            if (!typeFound) {
                return;
            }

            benefit.weight = typeFound.weight;
        }
    }

    healthInsuranceService.getLastActiveDeclaration('LUXMED').then(function (data) {
        if (data.status === 200) {
            $scope.last = data.data;
            if ($scope.last) {
                $scope.link = 'root.home.healthInsuranceWithPayments.list';
            } else {
                $scope.link = '';
            }

            updatePackageWeight();
        }
        $scope.$emit('link', $scope.link);
    });

    // @TODO <HEALTH2019>
    packageService.dataHealthGroupedPackageLists().then(function (data) {
        $scope.package = data.data.group;
        updatePackageWeight();
    });
    // @TODO </HEALTH2019>

    $scope.userData = dataUser.getLocal();
    $scope.branch = JSON.parse($scope.userData).person.branch;


    function determineProposedDate() {
        var date = new Date();
        var dayOfMonth = date.getDate();
        var requiredDayOfMonth = $rootScope.CONFIGURATOR.healthInsurance.orderPackageDayLimit;

        // @TODO <Exception for IC>
        if ($rootScope.CONFIGURATOR.companyCodename === 'intercity') {

            var interCityExceptionDate = new Date('2019', '10', '20', '23', '59');

            if (date <= interCityExceptionDate) {

                date = new Date(2019, 11);
                return moment(date).format('YYYY-MM-DD');

            }
        }
        // @TODO </Exception for IC>

        if (dayOfMonth <= requiredDayOfMonth) {
            // to najbliższy
            date = new Date(date.getFullYear(), date.getMonth() + 1);
            return moment(date).format('YYYY-MM-DD');
        } else {
            // to +1 miesiąc
            date = new Date(date.getFullYear(), date.getMonth() + 2);
            return moment(date).format('YYYY-MM-DD');
        }
    }

    $scope.proposedDate = determineProposedDate();
}]);
